// Keep in sync with MAX_ACTIVE_API_KEYS_PER_USER in backend/src/models/ApiKey.ts
export const MAX_ACTIVE_API_KEYS_PER_USER = 5;
